import "./index.css";
import { UserOverview } from "@/pages/Settings/components/UserOverview";
import ClientDetails from "@/pages/Settings/ClientDetails";
import InspectorDetails from "@/pages/Settings/InspectorDetails";
import ContractorDetails from "@/pages/Settings/ContractorDetails";
import LoanOfficerDetails from "@/pages/Settings/LoanOfficerDetails";
import LoanProcessorDetails from "@/pages/Settings/LoanProcessorDetails";

export const ProfileSettings = () => {
  return (
    <div className="settings-content">
      <UserOverview />
      {/*  TODO: Will make DetailsByRole component */}
      <ClientDetails />
      <InspectorDetails />
      <ContractorDetails />
      <LoanOfficerDetails />
      <LoanProcessorDetails />
    </div>
  );
};
